import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';
import moment from 'moment';

import TouchableElement from '@components/common/touchableElement';
import Button from '@components/button';

import { scale } from '@components/frame';
import { navigateTo, convertTimeLetter, getSecureValue, navigateBack } from '@helpers';

import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { getBoxShadowStyle } from '@styles/shadow';
import { useForceUpdateEverySecond } from '@v2/pages/common/hooks/useForceUpdateEverySecond';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

const Time = React.memo(({ startedOn, C }) => {
  useForceUpdateEverySecond();

  const min15 = 15 * 60;
  const pass = moment.utc().diff(moment.utc(startedOn), 's');
  const left = min15 - pass;

  if (left <= 0 || !startedOn) {
    return null;
  }

  const data = convertTimeLetter(Math.abs(left));
  return (
    <Text
      style={[
        font['Body'],
        { color: C('Label/Light/Quaternary'), marginTop: scale(6), width: '100%', textAlign: 'center', fontVariant: ['tabular-nums'] },
      ]}
    >
      {data.m}:{data.s} {i18n.t('left to setup')}
    </Text>
  );
});

const ConnectorSetup = (props) => {
  const { C, hide, onBoarding, logOnboarding } = props;

  const isMultipleConnectors = onBoarding?.onboardingStatus === 'MultipleConnectorsFound';
  return (
    <View style={{ width: '100%', paddingHorizontal: scale(6) }}>
      <View style={{ width: '100%', height: 420, backgroundColor: C(modalFieldBg), borderRadius: scale(40), alignItems: 'center' }}>
        <TouchableElement
          onPress={() => {
            logOnboarding('Component: Setup Popup. Action: Press close', { component: 'Setup Popup', action: 'Press close' });
            if (hide) {
              hide();
            } else {
              navigateBack();
            }
          }}
        >
          {({ boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  backgroundColor: C('Button/Light/Secondary'),
                  width: scale(20),
                  height: scale(20),
                  borderRadius: scale(20),
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: scale(20),
                  right: scale(20),
                  zIndex: 1000,
                },
              ]}
            >
              <Svg icon="times" width={scale(9)} height={scale(9)} color={'Button/Light/Only Text Text'} />
            </View>
          )}
        </TouchableElement>
        <View>
          <Text
            style={[
              font['Title 1'],
              {
                color: C('Label/Light/Primary'),
                marginTop: scale(46),
                width: '100%',
                textAlign: 'center',
                paddingHorizontal: scale(61),
              },
            ]}
          >
            {i18n.t(isMultipleConnectors ? 'Multiple Connectors Found' : 'Connector Found')}
          </Text>
        </View>
        <View
          style={[
            getBoxShadowStyle({ type: 'Narrow', C }),
            {
              marginTop: scale(isMultipleConnectors ? 39 : 58),
              height: scale(108),
              width: scale(120),
              borderRadius: scale(12),
              backgroundColor: C('Background / Light / Field'),
              alignItems: 'center',
            },
          ]}
        >
          <View style={{ marginTop: scale(14) }}>
            <Svg icon="smartIcon" width={scale(48)} height={scale(62)} color="Other/Light/Logo/Factory" />
          </View>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary'), marginTop: scale(7), zIndex: 1000 }]}>{i18n.t('Connector')}</Text>
        </View>
        <View style={{ alignItems: 'center' }}>
          <Text style={[font['Body'], { color: C('Label/Light/Quaternary'), marginTop: scale(10), width: '100%', textAlign: 'center' }]}>
            {onBoarding?.unregisteredConnector?.localHost}
          </Text>
          <Time {...{ startedOn: onBoarding?.unregisteredConnector?.startedOn, C }} />
        </View>
        <View style={{ width: '100%', paddingHorizontal: scale(61), marginTop: scale(30) }}>
          <Button
            {...{
              name: i18n.t('Setup'),
              onPress: async () => {
                if (hide) {
                  hide();
                }
                const isAuthorized = getSecureValue('token');

                logOnboarding(`Component: Setup Popup. Action: Press Setup. User authorized: ${Boolean(isAuthorized)}`, {
                  component: 'Setup Popup',
                  action: 'Press Setup',
                });

                if (isAuthorized) {
                  navigateTo('Settings', { screen: 'LinkConnector' });
                } else {
                  navigateTo('ConnectorSetup', { title: isAuthorized ? 'Setup Complete!' : false, fromModal: true });
                }
              },
              height: scale(45),
              width: '100%',
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default connect(({ onBoarding }) => ({ onBoarding }), {})(ColorWrapper(ConnectorSetup));
